var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",style:(("z-index:" + _vm.zIndex)),attrs:{"data-type":_vm.type}},[_c('div',{staticClass:"circle",style:(("z-index:" + (_vm.zIndex + 1)))})])}
var staticRenderFns = []

export { render, staticRenderFns }